import { render } from "./Gravatar.vue?vue&type=template&id=4469cb82"
import script from "./Gravatar.vue?vue&type=script&lang=js"
export * from "./Gravatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__